module.exports = __webpack_public_path__ + "img/01.8d689066.png";